(() => {
  if (window.__nooklumeCollectionDescriptionBound) return;
  window.__nooklumeCollectionDescriptionBound = true;

  const selector = '[data-nl-collection-description]';

  const refresh = (root) => {
    const content = root.querySelector('[data-nl-collection-description-content]');
    const button = root.querySelector('[data-nl-collection-description-toggle]');
    if (!content || !button) return;

    if (root.hasAttribute('data-nl-description-short')) {
      content.classList.remove('is-collapsed');
      button.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      return;
    }

    const wasOpen = button.getAttribute('aria-expanded') === 'true';
    content.classList.add('is-collapsed');
    const canExpand = content.scrollHeight > content.clientHeight + 2;

    if (!canExpand) {
      content.classList.remove('is-collapsed');
      button.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      return;
    }

    content.classList.toggle('is-collapsed', !wasOpen);
    button.hidden = false;
    button.setAttribute('aria-expanded', String(wasOpen));
    const label = button.querySelector('[data-nl-collection-description-label]');
    if (label) label.textContent = wasOpen ? 'View less' : 'View more';
  };

  const refreshAll = () => {
    document.querySelectorAll(selector).forEach(refresh);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll, { once: true });
  } else {
    refreshAll();
  }

  document.addEventListener('shopify:section:load', refreshAll);
  window.addEventListener('resize', refreshAll);
  if (document.fonts?.ready) document.fonts.ready.then(refreshAll);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-nl-collection-description-toggle]');
    if (!button || button.hidden) return;
    const root = button.closest(selector);
    const content = root?.querySelector('[data-nl-collection-description-content]');
    if (!content) return;

    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    content.classList.toggle('is-collapsed', !open);
    const label = button.querySelector('[data-nl-collection-description-label]');
    if (label) label.textContent = open ? 'View less' : 'View more';
  });
})();
